import { render, staticRenderFns } from "./SelectFacilityUser.vue?vue&type=template&id=70f17bc2&"
import script from "./SelectFacilityUser.vue?vue&type=script&lang=js&"
export * from "./SelectFacilityUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports